<div *ngIf="systemMessages.data$.value.length"  class="nsc-system__message">
  <nsc-card class="nsc-card--error">
    <nsc-card-title [error]="true">System Messages</nsc-card-title>
    <nsc-card-content>
      <div class="mat-typography">
        <p *ngFor="let message of systemMessages.data$.value">
          <strong>{{ message.titleDescription }}</strong>: <span [innerHtml]="message.message | safeHtml:'html'"></span>
        </p>
      </div>
    </nsc-card-content>
  </nsc-card>

  <nsc-spacer size="md"></nsc-spacer>
</div>
